import { PHeading } from "@porsche-design-system/components-react"
import type { PageTeaserView } from "@slfinrtl/ui-bff-routes"
import type { JSX } from "react"
import { BackNavigation } from "../backNavigation/BackNavigation"
import { Skeleton } from "../skeleton/Skeleton"
import { StickyHeader } from "../stickyHeader/StickyHeader"
import { PageTeaserTags } from "./PageTeaserTags"
import { getPageTeaserValue, isPageTeaserSkeletonMarker } from "./pageTeaserView.utils"

interface PageTeaserStickyHeaderProps {
	actionButton?: JSX.Element
	view: PageTeaserView
}

export const PageTeaserStickyHeader = ({ actionButton, view }: PageTeaserStickyHeaderProps) => {
	const heading = getPageTeaserValue(view.heading)

	return (
		<div data-testid="page-teaser-sticky-header">
			<StickyHeader rightChild={actionButton}>
				<BackNavigation hideLabel />
				{isPageTeaserSkeletonMarker(view.heading) ? (
					<Skeleton.Heading size="sm" $width="40%" />
				) : (
					heading && (
						<PHeading size="sm" ellipsis>
							{heading}
						</PHeading>
					)
				)}
				<PageTeaserTags isWithinStickyHeader view={view.tags} />
			</StickyHeader>
		</div>
	)
}
